import api from "./axios";

export const getSalesOrders =
() =>
api.get(
  "/sales-orders"
);

export const createSalesOrder =
(data)=>
api.post(
  "/sales-orders",
  data
);

export const getSalesOrderById =
(id)=>
api.get(
  `/sales-orders/${id}`
);